import styled from '@emotion/styled';
import CaretV2Icon from '../SvgIcons/CaretV2';
import Checkmark from '../SvgIcons/Checkmark';
import { FONT, SPACING } from '../../styles/emotion';
import COLORS from '../../styles/emotion/colors3';

export const ChipContainer = styled.button<{
  selected?: boolean;
  active?: boolean;
  twoLines?: boolean;
  width?: string;
  withImg?: boolean;
  large?: boolean;
  noBorder?: boolean;
}>`
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: 16px;
  color: var(--button-secondary-foreground, ${COLORS.BLACK_100});
  background-color: var(--background-screen, ${COLORS.WHITE_100});
  ${({ noBorder }) =>
    noBorder
      ? `border: none;`
      : `border: 1px solid var(--button-secondary-foreground, ${COLORS.BLACK_030});`};
  border-radius: 16px;
  cursor: pointer;
  padding: ${SPACING.SM} ${SPACING.S16};

  ${({ width }) => width && `width: ${width}`};
  &:hover {
    border-color: var(--button-secondary-focus-foreground, ${COLORS.BLACK_050});
    background-color: var(--button-secondary-focus-background, ${COLORS.BLACK_005});
  }

  &:focus-visible {
    outline: 5px auto Highlight;
    outline: 5px auto -webkit-focus-ring-color;
  }

  &:disabled {
    background-color: var(--button-secondary-disabled-background, ${COLORS.WHITE_100});
    border-color: var(--button-secondary-disabled-foreground, ${COLORS.BLACK_030});
    color: var(--button-secondary-disabled-foreground, ${COLORS.BLACK_030});
  }

  ${({ selected, active }) =>
    (selected || active) &&
    `
    color: var(--button-secondary-focus-foreground, ${COLORS.BLACK_100});
    border-color: var(--button-secondary-focus-foreground, ${COLORS.BLACK_100});
    background-color: var(--button-secondary-focus-background, ${COLORS.BLACK_005});
    &:hover {
      color: var(--button-secondary-focus-foreground, ${COLORS.BLACK_100});
      border-color: var(--button-secondary-focus-foreground, ${COLORS.BLACK_100});
      background-color: var(--button-secondary-focus-background, ${COLORS.BLACK_010});
    }
    `};

  ${({ large }) =>
    large &&
    `
    line-height: 24px;
    padding: ${SPACING.S16} ${SPACING.S16};
  `};

  ${({ twoLines }) =>
    twoLines &&
    `
    height: 62px;
    line-height: ${SPACING.MD};
    padding-top: 0;
    padding-bottom: 0;
    margin-right: ${SPACING.SM};
  `};

  ${({ withImg }) =>
    withImg &&
    `
    padding: ${SPACING.XS} ${SPACING.XS};
  `};
`;

export const StyledWrapper = styled.div<{
  withImg?: boolean;
  withCaret?: boolean;
  withIcon?: boolean;
  withIconPositionTop?: boolean;
  withHed?: boolean;
}>`
  text-align: center;

  ${({ withImg }) =>
    withImg &&
    `
    text-align: left;
    padding: ${SPACING.XS} ${SPACING.XS};
  `};

  ${({ withCaret }) =>
    withCaret &&
    `
    display: flex;
    align-items: center;
  `};

  ${({ withIcon }) =>
    withIcon &&
    `
    line-height: 24px;
    text-align: left;
    display: flex;
    align-items: flex-start;
  `};

  ${({ withIconPositionTop }) =>
    withIconPositionTop &&
    `
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${SPACING.XS};
  `};

  ${({ withHed }) =>
    withHed &&
    `
    text-align: left;
  `};
`;

export const StyledCaret = styled(CaretV2Icon)<{ disabled?: boolean; selected?: boolean }>`
  color: ${({ disabled }) =>
    disabled
      ? `var(--button-secondary-disabled-foreground, ${COLORS.BLACK_030})`
      : `var(--button-secondary-foreground, ${COLORS.BLACK_100})`};
  margin-left: ${SPACING.XS};
  width: auto !important;
  max-width: 14px;
  ${({ selected }) =>
    selected &&
    `
    transform: rotate(180deg);
    padding-top: 2px;
    `};
  transition: transform 0.2s ease;
`;

export const StyledCheckmark = styled(Checkmark)`
  margin-right: ${SPACING.XXS};
  height: 12px;
  width: 12px;
`;

export const StyledImg = styled.div`
  margin-bottom: ${SPACING.XS};

  img {
    border-radius: 8px;
    width: 100%;
  }
`;

export const StyledHedDek = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.XXS};
`;

export const StyledHed = styled.div`
  line-height: 24px;
`;

export const StyledDek = styled.div`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  color: ${COLORS.BLACK_075};
  line-height: 20px;
`;

export const StyledIcon = styled.span`
  margin-right: ${SPACING.XS};
  display: flex;
  align-items: center;

  svg,
  img {
    width: 24px !important;
    height: 24px !important;
  }

  &.top {
    width: 100%;
  }
`;
